import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./Menupage.css";
import Footer from "./Footer";
import LanguageDropdown from "../components/LanguageDropdown";
import PrivacyModal from "../components/PrivacyModal";
import CommonPopup from "./CommonPopup";
import useInactivityRedirect from "./useInactivityRedirect";
import LoadingSpinner from "../components/LoadingSpinner";

function Menupage() {
  const { t } = useTranslation("menupage");
  const [managers, setManagers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const {
    showPopup,
    confirmRedirect,
    cancelRedirect,
    remainingSeconds,
  } = useInactivityRedirect({
    inactivityTimeout:  60 * 1000,
    popupTimeout: 15 * 1000,
    redirectTo: "/",
  });

  useEffect(() => {

    if (!sessionStorage.getItem("UNITCODE")) {
      alert(t("unauthorized")); 
      navigate("/"); 
    } 

    const timer = setTimeout(() => setLoading(false), 400);
    return () => clearTimeout(timer);
  }, [navigate, t]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const confirmModal = () => {
    setIsModalOpen(false);
    navigate("/Lockerlocations/R");
  };

  const goStoragelocationF = () => {
    navigate("/Lockerlocations/F");
  };

  const goStoragelocationO = () => {
    navigate("/Lockerlocations/O");
  };

  if (loading) return <LoadingSpinner message="Loading..." />;

  return (
    <div className="wrap">
      <header>
        <div className="title" onClick={() => navigate("/")}>
          <h1 dangerouslySetInnerHTML={{ __html: t("select_menu") }} />
        </div>
        <LanguageDropdown />
      </header>

      <PrivacyModal isOpen={isModalOpen} onClose={closeModal} onConfirm={confirmModal} />

      <main className="content">
        <div className="link_wrap" style={{ zIndex: 1 }}>
          <div id="btn-modal" onClick={openModal}>
            <div className="link_inner">
              <h2>{t("reserve_locker")}</h2>
              <span>{t("reserve_desc")}</span>
            </div>
          </div>
          <div onClick={goStoragelocationF}>
            <div className="link_inner">
              <h2>{t("find_item")}</h2>
              <span>{t("find_desc")}</span>
            </div>
          </div>
          <div onClick={goStoragelocationO}>
            <div className="link_inner">
              <h2>{t("open_locker")}</h2>
              <span>{t("open_desc")}</span>
            </div>
          </div>
        </div>
      </main>

      {showPopup && (
        <CommonPopup
          visible={true}
          message={`${t("continue_question")}<br/><span style="font-weight:700;color:red">(${remainingSeconds} ${t("seconds")})</span>${t("auto_redirect")}`}
          onConfirm={confirmRedirect}
          onClose={cancelRedirect}
          confirmText={t("yes")}
          cancelText={t("no")}
        />
      )}

      <Footer />
    </div>
  );
}

export default Menupage;
